import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";

export default function Methods() {
  const { t } = useLang();
  const M = t.methods;
  return (
    <section
      id="methods"
      data-testid="methods-section"
      className="relative border-b border-white/10 py-28 lg:py-36"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-6 mb-16">
          <div className="col-span-12 lg:col-span-6">
            <div className="label-mono mb-4">{M.label}</div>
            <h2 className="display-2 text-4xl md:text-5xl lg:text-6xl text-white">
              {M.title_a}
              <br />
              <span className="text-[#FF3333]">{M.title_b}</span>{" "}
              <span className="text-white/40 italic font-light">{M.title_italic}</span>
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-5 lg:col-start-8 self-end">
            <p className="text-white/70 text-base leading-relaxed">{M.intro}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border border-white/10">
          {M.items.map((m, i) => {
            const code = `M.${String(i + 1).padStart(2, "0")}`;
            return (
              <motion.div
                key={code}
                data-testid={`method-${i}`}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.5, delay: (i % 4) * 0.07 }}
                className={`group relative p-8 ${(i + 1) % 4 !== 0 ? "lg:border-r" : ""} ${
                  i < M.items.length - 4 ? "lg:border-b" : ""
                } ${i % 2 === 0 ? "md:border-r lg:border-r" : ""} ${
                  i < M.items.length - 2 ? "md:border-b" : ""
                } border-white/10 hover:bg-[#1C1C1E] transition-colors`}
              >
                <div className="flex items-start justify-between mb-6">
                  <span className="font-mono text-[10px] tracking-widest uppercase text-[#FF3333]">
                    {code}
                  </span>
                  <span className="font-mono text-[10px] tracking-widest uppercase text-white/30 group-hover:text-white transition-colors">
                    →
                  </span>
                </div>
                <h3 className="font-display font-bold text-xl text-white mb-3">{m.name}</h3>
                <p className="text-white/55 text-sm leading-relaxed">{m.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
